import React from 'react';
import useTabParam from '../../hooks/useTabParam';
import OtherTransaction from './OtherTransaction';
import OrderTransaction from './OrderTransaction';
import WalletStatement from './WalletStatement';
import { Box } from '@mui/material';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import PageTitle from '../../components/PageTitle';

const MerchantTransaction = () => {
    const [value, setValue] = useTabParam("1");

    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };

    return (
            <>
                <PageTitle>Merchant Transactions</PageTitle>
                <TabContext value={value}>
                    <Box sx={{ backgroundColor: "#fff", boxShadow: 1 }}>
                        <TabList
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            sx={{
                                "& .MuiTab-root": {
                                    px: 7,
                                    py: 2,
                                },
                            }}
                        >
                            <Tab
                                iconPosition="top"
                                label="Order Transaction History"
                                value="1"
                            />
                            <Tab
                                label="Other Transaction History"
                                value="2"
                                iconPosition="top"
                            />
                            <Tab
                                label="Statement (Cross-Wallet)"
                                value="3"
                                iconPosition="top"
                            />
                        </TabList>
                    </Box>
                    <TabPanel value="1" sx={{ px: 0 }}>
                        <OrderTransaction />
                    </TabPanel>
                    <TabPanel value="2" sx={{ px: 0 }}>
                        <OtherTransaction />
                    </TabPanel>
                    <TabPanel value="3" sx={{ px: 0 }}>
                        <WalletStatement />
                    </TabPanel>
                </TabContext>
            </>
    );
}

export default MerchantTransaction;
